import React from "react";
import styled from "styled-components";

function TableTab({ style, list, tab, setTab }) {
  return (
    <>
      <TableTabWrapper style={{ ...style }}>
        {list.map((item, index) => {
          return (
            <Tab
              key={index}
              style={{
                color: `${tab === item.index ? "#27BEFF" : ""}`,
                borderBottom: `${
                  tab === item.index ? "2px solid #27BEFF" : ""
                }`,
              }}
              onClick={() => {
                setTab(item.index);
                sessionStorage.setItem("tab", item.index);
              }}
            >
              {item.title}
            </Tab>
          );
        })}
      </TableTabWrapper>
    </>
  );
}

export default TableTab;

const TableTabWrapper = styled.div.attrs((props) => {})`
  width: 924px;
  height: 43px;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 42px;
`;

const Tab = styled.div.attrs((props) => {})`
  width: 140px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-bottom: 10px;
  color: #939393;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px; /* 162.5% */
  letter-spacing: -0.054px;
  cursor: pointer;
`;
